import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getArticles } from '../lib/api';
import { SEO } from '../components/SEO';
import { BookOpen } from 'lucide-react';

export default function GuidesPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getArticles().then(res => { setArticles(res.data.filter(a => a.is_published)); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center"><div className="animate-pulse text-slate-400">Loading...</div></div>;
  }

  const categories = [...new Set(articles.map(a => a.category))];

  return (
    <div data-testid="guides-page">
      <SEO
        title="Educational Trading Guides"
        description="Build your trading knowledge with comprehensive guides on forex strategies, technical analysis, risk management, money management, and financial planning."
        canonical="/guides"
      />
      <section className="bg-slate-900 text-white py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight font-['Outfit'] mb-4">
            Educational Guides
          </h1>
          <p className="text-base text-slate-300 max-w-2xl">
            Build your trading knowledge with our comprehensive guides on broker selection, risk management, money management, and financial planning.
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {categories.map(category => (
          <div key={category} className="mb-12">
            <div className="flex items-center gap-2 mb-6">
              <BookOpen className="w-5 h-5 text-blue-600" />
              <h2 className="text-xl sm:text-2xl font-semibold text-slate-900 font-['Outfit']">{category}</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.filter(a => a.category === category).map(article => (
                <Link
                  key={article.slug}
                  to={`/guides/${article.slug}`}
                  className="group bg-white border border-slate-200 rounded-xl overflow-hidden hover:border-slate-300 hover:shadow-sm transition-all duration-200"
                  data-testid={`guide-card-${article.slug}`}
                >
                  <div className="aspect-[16/9] bg-slate-100 overflow-hidden">
                    <img
                      src={article.image_url}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <span className="text-xs font-medium text-blue-600 uppercase tracking-wider">{article.category}</span>
                    <h3 className="text-lg font-semibold text-slate-900 mt-1.5 mb-2 group-hover:text-blue-600 transition-colors font-['Outfit']">
                      {article.title}
                    </h3>
                    <p className="text-sm text-slate-600 line-clamp-2 mb-3">{article.excerpt}</p>
                    <span className="text-xs text-slate-400">{article.reading_time}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
